import ReportReceiptSubmission from "./ReportReceiptSubmission";

export default ReportReceiptSubmission;
